import { FamilyApplicationEndpoints } from '@/apis/family_application/requests.ts'
import { RequestResponse } from '@/app/common/types_and_interfaces'
import { parseRequestError } from '@/common/utilities.ts'
import axiosInstance from '@/libs/axios_config.ts'
// import { useMutation } from "@tanstack/react-query"
import { z } from 'zod'

const PostBCResponseSchema = z.object({
  document_variation_id: z.number(),
  result: z.string(),
})

export type PostBCResponse = z.infer<typeof PostBCResponseSchema>

// // Define the custom hook income verification
// export const usePostBirthCertificateIncome = () => {
//   return useMutation<PostBCResponse, Error, FormData>({
//     mutationFn: async (payload: FormData) => {
//       try {
//         const response = await axiosInstance.post(
//           FamilyApplicationEndpoints.post_income_document_verification,
//           payload,
//           {
//             headers: {
//               "Content-Type": "multipart/form-data"
//             }
//           }
//         )
//         return PostBCResponseSchema.parse(response.data)
//       } catch (error) {
//         throw parseRequestError(error)
//       }
//     },
//   })
// }

export const SubmitIncome = async (
  payload: FormData
): Promise<RequestResponse<PostBCResponse>> => {
  try {
    const response = await axiosInstance.post(
      FamilyApplicationEndpoints.post_income_document_verification,
      payload,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )
    const cleanResponse = PostBCResponseSchema.parse(response.data)
    return { data: cleanResponse, error: null }
  } catch (error) {
    return { data: null, error: parseRequestError(error) }
  }
}
